import React from "react";
import trace from "../../assets/images/traceChart.svg";
import trace_active from "../../assets/images/traceChart_active.svg";

export default function TracePolylinesChart({
  isDotsChartActive,
  setIsDotsChartActive,
}) {
  const handleSwitchTrace = () => {
    setIsDotsChartActive(!isDotsChartActive);
  };
  return (
    <div className="dotsChart_div1">
      <img
        src={isDotsChartActive ? trace_active : trace}
        onClick={handleSwitchTrace}
        height="20"
        className="d-inline-block"
        alt="radar"
      />
    </div>
  );
}
